"use client";

import { useTranslations } from "next-intl";

/**
 * Ссылка «перейти к содержимому» (KAN-1007).
 *
 * Первый фокусируемый элемент страницы: пользователь клавиатуры и скринридера
 * перепрыгивает шапку с её меню и попадает сразу в <main id="main-content">.
 * Видна только при фокусе — мышью её никто не увидит.
 *
 * Цель (`#main-content`) живёт в лейаутах `(browse)`, `(protected)`,
 * `(marketing)` и `rosters`. Если появится новый лейаут со своим <main>,
 * идентификатор нужен и там, иначе ссылка будет вести в пустоту.
 */
export function SkipToContent() {
  const t = useTranslations("A11y");

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
    >
      {t("skipToContent")}
    </a>
  );
}
